import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/useAuthStore';

interface AuthGuardProps {
  children: React.ReactNode;
  requireAuth?: boolean;
}

export default function AuthGuard({ children, requireAuth = false }: AuthGuardProps) {
  const { isAuthenticated, loading } = useAuthStore();
  const location = useLocation();

  // Allow access to guests if authentication is not required.
  // Public routes render immediately so we don't flash a spinner while
  // the auth store hydrates from Supabase on initial mount.
  if (!requireAuth) {
    return <>{children}</>;
  }

  // For protected routes, wait for the auth store to finish hydrating
  // before deciding whether to redirect.
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}